export { isPageNavigationUrl, isSamePageHashNavigation } from './navigationRules.ts'
export { SwupPagePreloadPlugin } from './plugins/preloader/index.ts'
export type {
  PagePreloader,
  PagePreloaderOptions,
  PreloadOptions,
  PreloadStrategy,
} from './plugins/preloader/index.ts'
export { createSwup } from './swupAdapter.ts'
